// onClick handler for selecting and deselecting a filter
const clearAllFilters = (setSelectedFilters, setCurrentPageNumber) => {
	setSelectedFilters([]);
	setCurrentPageNumber(1);
};

export default clearAllFilters;